export { MultiSectionDigitalClock } from './MultiSectionDigitalClock';
export type {
  MultiSectionDigitalClockProps,
  MultiSectionDigitalClockSlots,
  MultiSectionDigitalClockSlotProps,
} from './MultiSectionDigitalClock.types';

export { multiSectionDigitalClockSectionClasses } from './multiSectionDigitalClockSectionClasses';
export type {
  MultiSectionDigitalClockSectionClasses,
  MultiSectionDigitalClockSectionClassKey,
} from './multiSectionDigitalClockSectionClasses';
export type { ExportedMultiSectionDigitalClockSectionProps } from './MultiSectionDigitalClockSection';
export {
  multiSectionDigitalClockClasses,
  getMultiSectionDigitalClockUtilityClass,
} from './multiSectionDigitalClockClasses';
export type {
  MultiSectionDigitalClockClasses,
  MultiSectionDigitalClockClassKey,
} from './multiSectionDigitalClockClasses';
